// This is auto generated files. DO NOT EDIT DIRECTLY
import type { Exact, InputMaybe, Locales, Scalars, ArticlePageWhereInput, AssetPageWhereInput, PersonPageWhereInput, LocationPageWhereInput, PageBaseWhereInput, PageBaseOrderByInput, RealestatePageWhereInput } from './cms-types';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(endpoint: string, requestInit: RequestInit, query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint, {
      method: 'POST',
      ...requestInit,
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ArticleListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  mediatype?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  theme?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  author?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<ArticlePageWhereInput>;
}>;


export type ArticleListingQuery = { __typename?: 'Query', ArticlePage?: { __typename?: 'ArticlePageOutput', total?: number | null, items?: Array<{ __typename?: 'ArticlePage', Name?: string | null, Url?: string | null, Title?: string | null, PreviewTitle?: string | null, PreviewDescription?: string | null, DisplayedWithCoAuthorsCoBrands?: any | null, ArticlePublishDate?: any | null, ReadTimeInMins?: number | null, VideoUrl?: string | null, WatchTimeInMins?: number | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null, GuidValue?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ArticleListingPage' } | { __typename: 'ArticlePage' } | { __typename: 'AssetListingPage' } | { __typename: 'AssetPage' } | { __typename: 'CoAuthorBlock', Name?: string | null, Role?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, BadgeImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | { __typename: 'Content' } | { __typename: 'Country' } | { __typename: 'FTLandingPage' } | { __typename: 'HomePage' } | { __typename: 'ImageFile' } | { __typename: 'LessonPage' } | { __typename: 'LocationListingPage' } | { __typename: 'LocationPage' } | { __typename: 'NotFoundPage' } | { __typename: 'PageBase' } | { __typename: 'PdfFile' } | { __typename: 'PeopleListingPage' } | { __typename: 'PersonPage', Name?: string | null, Role?: string | null, PreviewDescription?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | { __typename: 'RealestateListingPage' } | { __typename: 'RealestatePage' } | { __typename: 'SearchPage' } | { __typename: 'StandardPage' } | { __typename: 'VectorImageFile' } | null } | null } | null> | null, MediaTypeCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null } | null> | null, ThemeCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null } | null> | null } | null> | null, facets?: { __typename?: 'ArticlePageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, MediaTypeCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, ThemeCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, Authors?: { __typename?: 'ContentAreaItemModelSearchFacet', ContentLink?: { __typename?: 'ContentModelReferenceSearchFacet', GuidValue?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null } | null };

export type AssetsListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assettype?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  headoffice?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<AssetPageWhereInput>;
}>;


export type AssetsListingQuery = { __typename?: 'Query', AssetPage?: { __typename?: 'AssetPageOutput', total?: number | null, items?: Array<{ __typename?: 'AssetPage', PreviewTitle?: string | null, Title?: string | null, PreviewDescription?: string | null, Latitude?: string | null, Longitude?: string | null, Url?: string | null, DateAcquired?: any | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, CountryItems?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country', Name?: string | null, PlaceId?: string | null } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile' } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | null> | null, HeadOffice?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country', Name?: string | null, PlaceId?: string | null } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile' } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, SectorCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Name?: string | null, Description?: string | null } | null> | null, AssetTypeCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Name?: string | null, Description?: string | null } | null> | null } | null> | null, facets?: { __typename?: 'AssetPageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, SectorCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, AssetTypeCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, HeadOffice?: { __typename?: 'ContentModelReferenceFacet', GuidValue?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null } | null } | null };

export type LocationListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationPageWhereInput>;
}>;


export type LocationListingQuery = { __typename?: 'Query', LocationPage?: { __typename?: 'LocationPageOutput', total?: number | null, items?: Array<{ __typename?: 'LocationPage', PreviewTitle?: string | null, Title?: string | null, PreviewDescription?: string | null, Address?: string | null, PhoneNumber?: string | null, FaxNumber?: string | null, Latitude?: string | null, Longitude?: string | null, Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, RegionCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Name?: string | null, Description?: string | null } | null> | null } | null> | null, facets?: { __typename?: 'LocationPageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, RegionCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, Description?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null };

export type PeopleListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<PersonPageWhereInput>;
}>;


export type PeopleListingQuery = { __typename?: 'Query', PersonPage?: { __typename?: 'PersonPageOutput', total?: number | null, items?: Array<{ __typename?: 'PersonPage', PreviewTitle?: string | null, Name?: string | null, Url?: string | null, PreviewDescription?: string | null, Role?: string | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | null> | null, facets?: { __typename?: 'PersonPageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, RegionCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null } | null } | null };

export type RealEstateListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  grade?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<RealestatePageWhereInput>;
}>;


export type RealEstateListingQuery = { __typename?: 'Query', RealestatePage?: { __typename?: 'RealestatePageOutput', total?: number | null, items?: Array<{ __typename?: 'RealestatePage', AssetName?: string | null, Excerpt?: string | null, AssetAddress?: string | null, Name?: string | null, Url?: string | null, PreviewTitle?: string | null, PreviewDescription?: string | null, Latitude?: string | null, Longitude?: string | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, GuidValue?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, SectorCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null, Name?: string | null } | null> | null, GradeCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null, Name?: string | null } | null> | null, StatusCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null, Name?: string | null } | null> | null, StateCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null, Name?: string | null } | null> | null } | null> | null, facets?: { __typename?: 'RealestatePageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, SectorCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, GradeCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, StatusCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, StateCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null } | null } | null };

export type SearchBlockQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contenttype?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<PageBaseWhereInput>;
  orderBy?: InputMaybe<PageBaseOrderByInput>;
}>;


export type SearchBlockQuery = { __typename?: 'Query', PageBase?: { __typename?: 'PageBaseOutput', total?: number | null, items?: Array<{ __typename?: 'PageBase', PreviewTitle?: string | null, Name?: string | null, Url?: string | null, ContentType?: Array<string | null> | null, PreviewDescription?: string | null, FileSize?: string | null, _score?: number | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null> | null, facets?: { __typename?: 'PageBaseFacet', ContentType?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null };

type Author_ArticleListingPage_Fragment = { __typename: 'ArticleListingPage' };

type Author_ArticlePage_Fragment = { __typename: 'ArticlePage' };

type Author_AssetListingPage_Fragment = { __typename: 'AssetListingPage' };

type Author_AssetPage_Fragment = { __typename: 'AssetPage' };

type Author_CoAuthorBlock_Fragment = { __typename: 'CoAuthorBlock', Name?: string | null, Role?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, BadgeImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null };

type Author_Content_Fragment = { __typename: 'Content' };

type Author_Country_Fragment = { __typename: 'Country' };

type Author_FtLandingPage_Fragment = { __typename: 'FTLandingPage' };

type Author_HomePage_Fragment = { __typename: 'HomePage' };

type Author_ImageFile_Fragment = { __typename: 'ImageFile' };

type Author_LessonPage_Fragment = { __typename: 'LessonPage' };

type Author_LocationListingPage_Fragment = { __typename: 'LocationListingPage' };

type Author_LocationPage_Fragment = { __typename: 'LocationPage' };

type Author_NotFoundPage_Fragment = { __typename: 'NotFoundPage' };

type Author_PageBase_Fragment = { __typename: 'PageBase' };

type Author_PdfFile_Fragment = { __typename: 'PdfFile' };

type Author_PeopleListingPage_Fragment = { __typename: 'PeopleListingPage' };

type Author_PersonPage_Fragment = { __typename: 'PersonPage', Name?: string | null, Role?: string | null, PreviewDescription?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'AssetListingPage' } | { __typename?: 'AssetPage' } | { __typename?: 'CoAuthorBlock' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'FTLandingPage' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LessonPage' } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'RealestateListingPage' } | { __typename?: 'RealestatePage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null };

type Author_RealestateListingPage_Fragment = { __typename: 'RealestateListingPage' };

type Author_RealestatePage_Fragment = { __typename: 'RealestatePage' };

type Author_SearchPage_Fragment = { __typename: 'SearchPage' };

type Author_StandardPage_Fragment = { __typename: 'StandardPage' };

type Author_VectorImageFile_Fragment = { __typename: 'VectorImageFile' };

export type AuthorFragment = Author_ArticleListingPage_Fragment | Author_ArticlePage_Fragment | Author_AssetListingPage_Fragment | Author_AssetPage_Fragment | Author_CoAuthorBlock_Fragment | Author_Content_Fragment | Author_Country_Fragment | Author_FtLandingPage_Fragment | Author_HomePage_Fragment | Author_ImageFile_Fragment | Author_LessonPage_Fragment | Author_LocationListingPage_Fragment | Author_LocationPage_Fragment | Author_NotFoundPage_Fragment | Author_PageBase_Fragment | Author_PdfFile_Fragment | Author_PeopleListingPage_Fragment | Author_PersonPage_Fragment | Author_RealestateListingPage_Fragment | Author_RealestatePage_Fragment | Author_SearchPage_Fragment | Author_StandardPage_Fragment | Author_VectorImageFile_Fragment;

export type CategoryFacetFragment = { __typename?: 'CategoryModelFacet', Description?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null };

export type CountryFragment = { __typename?: 'Country', Name?: string | null, PlaceId?: string | null };

export type ImageFragment = { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null };


export const ImageFragmentDoc = `
    fragment Image on ImageFile {
  Name
  Url
  Title
  Width
  Height
}
    `;
export const AuthorFragmentDoc = `
    fragment Author on IContent {
  __typename
  ... on PersonPage {
    Name
    Role
    PreviewDescription
    HeadshotImage {
      Expanded {
        ...Image
      }
    }
  }
  ... on CoAuthorBlock {
    Name
    Role
    HeadshotImage {
      Expanded {
        ...Image
      }
    }
    BadgeImage {
      Expanded {
        ...Image
      }
    }
  }
}
    `;
export const CategoryFacetFragmentDoc = `
    fragment CategoryFacet on CategoryModelFacet {
  Description(filters: $category) {
    name
    count
  }
}
    `;
export const CountryFragmentDoc = `
    fragment Country on Country {
  Name
  PlaceId
}
    `;
export const ArticleListingDocument = `
    query ArticleListing($locale: [Locales!] = en_US, $limit: Int = 50, $skip: Int = 0, $mediatype: [String!] = [], $theme: [String!] = [], $author: [String!] = [], $where: ArticlePageWhereInput) {
  ArticlePage(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: {ArticlePublishDate: DESC}
  ) {
    items {
      Name
      Url
      ContentLink {
        Url
        GuidValue
      }
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      Title
      PreviewTitle
      PreviewDescription
      DisplayedWithCoAuthorsCoBrands
      Authors {
        ContentLink {
          Expanded {
            ...Author
          }
        }
      }
      ArticlePublishDate
      ReadTimeInMins
      VideoUrl
      WatchTimeInMins
      MediaTypeCategories {
        Id
        Description
      }
      ThemeCategories {
        Id
        Description
      }
      _fulltext
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      MediaTypeCategories {
        Name(filters: $mediatype) {
          name
        }
      }
      ThemeCategories {
        Name(filters: $theme) {
          name
        }
      }
      Authors {
        ContentLink {
          GuidValue(filters: $author) {
            name
            count
          }
        }
      }
    }
  }
}
    ${ImageFragmentDoc}
${AuthorFragmentDoc}`;

export const useArticleListingQuery = <
      TData = ArticleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: ArticleListingQueryVariables,
      options?: UseQueryOptions<ArticleListingQuery, TError, TData>
    ) => {
    
    return useQuery<ArticleListingQuery, TError, TData>(
      variables === undefined ? ['ArticleListing'] : ['ArticleListing', variables],
      fetcher<ArticleListingQuery, ArticleListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, ArticleListingDocument, variables),
      options
    )};

export const AssetsListingDocument = `
    query AssetsListing($locale: [Locales!] = en_US, $limit: Int = 100, $skip: Int = 0, $sector: [String!] = [], $assettype: [String!] = [], $headoffice: [String!] = [], $where: AssetPageWhereInput) {
  AssetPage(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: {Name: ASC}
  ) {
    items {
      ContentLink {
        Id
        Url
      }
      PreviewTitle
      Title
      PreviewDescription
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      CountryItems {
        ContentLink {
          Expanded {
            ...Country
          }
        }
      }
      HeadOffice {
        Expanded {
          ...Country
        }
      }
      SectorCategories {
        Id
        Name
        Description
      }
      AssetTypeCategories {
        Id
        Name
        Description
      }
      Latitude
      Longitude
      Url
      DateAcquired
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      SectorCategories {
        Name(filters: $sector) {
          name
        }
      }
      AssetTypeCategories {
        Name(filters: $assettype) {
          name
        }
      }
      HeadOffice {
        GuidValue(filters: $headoffice) {
          name
        }
      }
    }
  }
}
    ${ImageFragmentDoc}
${CountryFragmentDoc}`;

export const useAssetsListingQuery = <
      TData = AssetsListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: AssetsListingQueryVariables,
      options?: UseQueryOptions<AssetsListingQuery, TError, TData>
    ) => {
    
    return useQuery<AssetsListingQuery, TError, TData>(
      variables === undefined ? ['AssetsListing'] : ['AssetsListing', variables],
      fetcher<AssetsListingQuery, AssetsListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, AssetsListingDocument, variables),
      options
    )};

export const LocationListingDocument = `
    query LocationListing($locale: [Locales!] = en_US, $limit: Int = 100, $skip: Int = 0, $where: LocationPageWhereInput) {
  LocationPage(locale: $locale, skip: $skip, limit: $limit, where: $where) {
    items {
      ContentLink {
        Id
        Url
      }
      PreviewTitle
      Title
      PreviewDescription
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      RegionCategories {
        Id
        Name
        Description
      }
      Address
      PhoneNumber
      FaxNumber
      Latitude
      Longitude
      Url
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      RegionCategories {
        Name {
          name
          count
        }
        Description {
          name
          count
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;

export const useLocationListingQuery = <
      TData = LocationListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: LocationListingQueryVariables,
      options?: UseQueryOptions<LocationListingQuery, TError, TData>
    ) => {
    
    return useQuery<LocationListingQuery, TError, TData>(
      variables === undefined ? ['LocationListing'] : ['LocationListing', variables],
      fetcher<LocationListingQuery, LocationListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, LocationListingDocument, variables),
      options
    )};

export const PeopleListingDocument = `
    query PeopleListing($locale: [Locales!] = en_US, $limit: Int = 50, $skip: Int = 0, $region: [String!] = [], $where: PersonPageWhereInput) {
  PersonPage(locale: $locale, skip: $skip, limit: $limit, where: $where) {
    items {
      ContentLink {
        GuidValue
        Url
      }
      PreviewTitle
      Name
      Url
      PreviewDescription
      Role
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      _fulltext
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      RegionCategories {
        Name(filters: $region) {
          name
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;

export const usePeopleListingQuery = <
      TData = PeopleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: PeopleListingQueryVariables,
      options?: UseQueryOptions<PeopleListingQuery, TError, TData>
    ) => {
    
    return useQuery<PeopleListingQuery, TError, TData>(
      variables === undefined ? ['PeopleListing'] : ['PeopleListing', variables],
      fetcher<PeopleListingQuery, PeopleListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, PeopleListingDocument, variables),
      options
    )};

export const RealEstateListingDocument = `
    query RealEstateListing($locale: [Locales!] = en_US, $limit: Int = 50, $skip: Int = 0, $sector: [String!] = [], $grade: [String!] = [], $status: [String!] = [], $state: [String!] = [], $where: RealestatePageWhereInput) {
  RealestatePage(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: {_ranking: RELEVANCE}
  ) {
    items {
      AssetName
      Excerpt
      AssetAddress
      Name
      Url
      ContentLink {
        Id
        Url
        GuidValue
      }
      PreviewTitle
      PreviewDescription
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      Latitude
      Longitude
      SectorCategories {
        Id
        Description
        Name
      }
      GradeCategories {
        Id
        Description
        Name
      }
      StatusCategories {
        Id
        Description
        Name
      }
      StateCategories {
        Id
        Description
        Name
      }
      _fulltext
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      SectorCategories {
        Name(filters: $sector) {
          name
        }
      }
      GradeCategories {
        Name(filters: $grade) {
          name
        }
      }
      StatusCategories {
        Name(filters: $status) {
          name
        }
      }
      StateCategories {
        Name(filters: $state) {
          name
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;

export const useRealEstateListingQuery = <
      TData = RealEstateListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: RealEstateListingQueryVariables,
      options?: UseQueryOptions<RealEstateListingQuery, TError, TData>
    ) => {
    
    return useQuery<RealEstateListingQuery, TError, TData>(
      variables === undefined ? ['RealEstateListing'] : ['RealEstateListing', variables],
      fetcher<RealEstateListingQuery, RealEstateListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, RealEstateListingDocument, variables),
      options
    )};

export const SearchBlockDocument = `
    query SearchBlock($locale: [Locales!] = en_US, $limit: Int = 50, $skip: Int = 0, $contenttype: [String!] = [], $where: PageBaseWhereInput, $orderBy: PageBaseOrderByInput) {
  PageBase(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: $orderBy
  ) {
    items {
      PreviewTitle
      Name
      Url
      ContentType
      ContentLink {
        GuidValue
        Url
      }
      PreviewDescription
      PreviewImage {
        Url
      }
      FileSize
      _score
      _fulltext
    }
    facets {
      ContentType(filters: $contenttype, limit: 20) {
        name
        count
      }
    }
    total(all: true)
  }
}
    `;

export const useSearchBlockQuery = <
      TData = SearchBlockQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: SearchBlockQueryVariables,
      options?: UseQueryOptions<SearchBlockQuery, TError, TData>
    ) => {
    
    return useQuery<SearchBlockQuery, TError, TData>(
      variables === undefined ? ['SearchBlock'] : ['SearchBlock', variables],
      fetcher<SearchBlockQuery, SearchBlockQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, SearchBlockDocument, variables),
      options
    )};


// Auto-generated hook to fetch ALL ArticleListing data by automatically paginating
export const useArticleListingAllQuery = <
      TData = ArticleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: Omit<ArticleListingQueryVariables, 'skip' | 'limit'>,
      options?: Omit<UseQueryOptions<ArticleListingQuery, TError, TData>, 'queryFn'>
    ) => {
    return useQuery<ArticleListingQuery, TError, TData>({
        queryKey: variables === undefined ? ['ArticleListingAll'] : ['ArticleListingAll', variables],
        queryFn: async () => {
            let allItems: any[] = [];
            let skip = 0;
            const limit = 100; // GraphQL server limit
            let hasMore = true;
            let totalCount = 0;
            let facets: any = null;

            while (hasMore) {
                const pageVariables = {
                    ...variables,
                    skip,
                    limit,
                };

                const result = await fetcher<ArticleListingQuery, ArticleListingQueryVariables>(
                    dataSource.endpoint,
                    dataSource.fetchParams || {},
                    ArticleListingDocument,
                    pageVariables
                )();

                if (!result.ArticlePage) {
                    break;
                }

                const { items, total, facets: pageFacets } = result.ArticlePage;

                if (skip === 0) {
                    totalCount = total || 0;
                    facets = pageFacets;
                }

                if (items) {
                    allItems = [...allItems, ...items];
                }

                hasMore = (items?.length || 0) === limit && allItems.length < totalCount;
                skip += limit;

                // Safety break to prevent infinite loops
                if (skip > 10000) {
                    console.warn('ArticleListing pagination safety break at 10000 items');
                    break;
                }
            }

            // Return the same structure as the original query but with all items
            return {
                ArticlePage: {
                    __typename: 'ArticlePageOutput' as const,
                    total: totalCount,
                    items: allItems,
                    facets,
                },
            } as ArticleListingQuery;
        },
        ...options,
    });
};

// Auto-generated hook to fetch ALL AssetsListing data by automatically paginating
export const useAssetsListingAllQuery = <
      TData = AssetsListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: Omit<AssetsListingQueryVariables, 'skip' | 'limit'>,
      options?: Omit<UseQueryOptions<AssetsListingQuery, TError, TData>, 'queryFn'>
    ) => {
    return useQuery<AssetsListingQuery, TError, TData>({
        queryKey: variables === undefined ? ['AssetsListingAll'] : ['AssetsListingAll', variables],
        queryFn: async () => {
            let allItems: any[] = [];
            let skip = 0;
            const limit = 100; // GraphQL server limit
            let hasMore = true;
            let totalCount = 0;
            let facets: any = null;

            while (hasMore) {
                const pageVariables = {
                    ...variables,
                    skip,
                    limit,
                };

                const result = await fetcher<AssetsListingQuery, AssetsListingQueryVariables>(
                    dataSource.endpoint,
                    dataSource.fetchParams || {},
                    AssetsListingDocument,
                    pageVariables
                )();

                if (!result.AssetPage) {
                    break;
                }

                const { items, total, facets: pageFacets } = result.AssetPage;

                if (skip === 0) {
                    totalCount = total || 0;
                    facets = pageFacets;
                }

                if (items) {
                    allItems = [...allItems, ...items];
                }

                hasMore = (items?.length || 0) === limit && allItems.length < totalCount;
                skip += limit;

                // Safety break to prevent infinite loops
                if (skip > 10000) {
                    console.warn('AssetsListing pagination safety break at 10000 items');
                    break;
                }
            }

            // Return the same structure as the original query but with all items
            return {
                AssetPage: {
                    __typename: 'AssetPageOutput' as const,
                    total: totalCount,
                    items: allItems,
                    facets,
                },
            } as AssetsListingQuery;
        },
        ...options,
    });
};

// Auto-generated hook to fetch ALL LocationListing data by automatically paginating
export const useLocationListingAllQuery = <
      TData = LocationListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: Omit<LocationListingQueryVariables, 'skip' | 'limit'>,
      options?: Omit<UseQueryOptions<LocationListingQuery, TError, TData>, 'queryFn'>
    ) => {
    return useQuery<LocationListingQuery, TError, TData>({
        queryKey: variables === undefined ? ['LocationListingAll'] : ['LocationListingAll', variables],
        queryFn: async () => {
            let allItems: any[] = [];
            let skip = 0;
            const limit = 100; // GraphQL server limit
            let hasMore = true;
            let totalCount = 0;
            let facets: any = null;

            while (hasMore) {
                const pageVariables = {
                    ...variables,
                    skip,
                    limit,
                };

                const result = await fetcher<LocationListingQuery, LocationListingQueryVariables>(
                    dataSource.endpoint,
                    dataSource.fetchParams || {},
                    LocationListingDocument,
                    pageVariables
                )();

                if (!result.LocationPage) {
                    break;
                }

                const { items, total, facets: pageFacets } = result.LocationPage;

                if (skip === 0) {
                    totalCount = total || 0;
                    facets = pageFacets;
                }

                if (items) {
                    allItems = [...allItems, ...items];
                }

                hasMore = (items?.length || 0) === limit && allItems.length < totalCount;
                skip += limit;

                // Safety break to prevent infinite loops
                if (skip > 10000) {
                    console.warn('LocationListing pagination safety break at 10000 items');
                    break;
                }
            }

            // Return the same structure as the original query but with all items
            return {
                LocationPage: {
                    __typename: 'LocationPageOutput' as const,
                    total: totalCount,
                    items: allItems,
                    facets,
                },
            } as LocationListingQuery;
        },
        ...options,
    });
};

// Auto-generated hook to fetch ALL PeopleListing data by automatically paginating
export const usePeopleListingAllQuery = <
      TData = PeopleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: Omit<PeopleListingQueryVariables, 'skip' | 'limit'>,
      options?: Omit<UseQueryOptions<PeopleListingQuery, TError, TData>, 'queryFn'>
    ) => {
    return useQuery<PeopleListingQuery, TError, TData>({
        queryKey: variables === undefined ? ['PeopleListingAll'] : ['PeopleListingAll', variables],
        queryFn: async () => {
            let allItems: any[] = [];
            let skip = 0;
            const limit = 100; // GraphQL server limit
            let hasMore = true;
            let totalCount = 0;
            let facets: any = null;

            while (hasMore) {
                const pageVariables = {
                    ...variables,
                    skip,
                    limit,
                };

                const result = await fetcher<PeopleListingQuery, PeopleListingQueryVariables>(
                    dataSource.endpoint,
                    dataSource.fetchParams || {},
                    PeopleListingDocument,
                    pageVariables
                )();

                if (!result.PersonPage) {
                    break;
                }

                const { items, total, facets: pageFacets } = result.PersonPage;

                if (skip === 0) {
                    totalCount = total || 0;
                    facets = pageFacets;
                }

                if (items) {
                    allItems = [...allItems, ...items];
                }

                hasMore = (items?.length || 0) === limit && allItems.length < totalCount;
                skip += limit;

                // Safety break to prevent infinite loops
                if (skip > 10000) {
                    console.warn('PeopleListing pagination safety break at 10000 items');
                    break;
                }
            }

            // Return the same structure as the original query but with all items
            return {
                PersonPage: {
                    __typename: 'PersonPageOutput' as const,
                    total: totalCount,
                    items: allItems,
                    facets,
                },
            } as PeopleListingQuery;
        },
        ...options,
    });
};

// Auto-generated hook to fetch ALL RealEstateListing data by automatically paginating
export const useRealEstateListingAllQuery = <
      TData = RealEstateListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: Omit<RealEstateListingQueryVariables, 'skip' | 'limit'>,
      options?: Omit<UseQueryOptions<RealEstateListingQuery, TError, TData>, 'queryFn'>
    ) => {
    return useQuery<RealEstateListingQuery, TError, TData>({
        queryKey: variables === undefined ? ['RealEstateListingAll'] : ['RealEstateListingAll', variables],
        queryFn: async () => {
            let allItems: any[] = [];
            let skip = 0;
            const limit = 100; // GraphQL server limit
            let hasMore = true;
            let totalCount = 0;
            let facets: any = null;

            while (hasMore) {
                const pageVariables = {
                    ...variables,
                    skip,
                    limit,
                };

                const result = await fetcher<RealEstateListingQuery, RealEstateListingQueryVariables>(
                    dataSource.endpoint,
                    dataSource.fetchParams || {},
                    RealEstateListingDocument,
                    pageVariables
                )();

                if (!result.RealestatePage) {
                    break;
                }

                const { items, total, facets: pageFacets } = result.RealestatePage;

                if (skip === 0) {
                    totalCount = total || 0;
                    facets = pageFacets;
                }

                if (items) {
                    allItems = [...allItems, ...items];
                }

                hasMore = (items?.length || 0) === limit && allItems.length < totalCount;
                skip += limit;

                // Safety break to prevent infinite loops
                if (skip > 10000) {
                    console.warn('RealEstateListing pagination safety break at 10000 items');
                    break;
                }
            }

            // Return the same structure as the original query but with all items
            return {
                RealestatePage: {
                    __typename: 'RealestatePageOutput' as const,
                    total: totalCount,
                    items: allItems,
                    facets,
                },
            } as RealEstateListingQuery;
        },
        ...options,
    });
};

// Auto-generated hook to fetch ALL SearchBlock data by automatically paginating
export const useSearchBlockAllQuery = <
      TData = SearchBlockQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: Omit<SearchBlockQueryVariables, 'skip' | 'limit'>,
      options?: Omit<UseQueryOptions<SearchBlockQuery, TError, TData>, 'queryFn'>
    ) => {
    return useQuery<SearchBlockQuery, TError, TData>({
        queryKey: variables === undefined ? ['SearchBlockAll'] : ['SearchBlockAll', variables],
        queryFn: async () => {
            let allItems: any[] = [];
            let skip = 0;
            const limit = 100; // GraphQL server limit
            let hasMore = true;
            let totalCount = 0;
            let facets: any = null;

            while (hasMore) {
                const pageVariables = {
                    ...variables,
                    skip,
                    limit,
                };

                const result = await fetcher<SearchBlockQuery, SearchBlockQueryVariables>(
                    dataSource.endpoint,
                    dataSource.fetchParams || {},
                    SearchBlockDocument,
                    pageVariables
                )();

                if (!result.PageBase) {
                    break;
                }

                const { items, total, facets: pageFacets } = result.PageBase;

                if (skip === 0) {
                    totalCount = total || 0;
                    facets = pageFacets;
                }

                if (items) {
                    allItems = [...allItems, ...items];
                }

                hasMore = (items?.length || 0) === limit && allItems.length < totalCount;
                skip += limit;

                // Safety break to prevent infinite loops
                if (skip > 10000) {
                    console.warn('SearchBlock pagination safety break at 10000 items');
                    break;
                }
            }

            // Return the same structure as the original query but with all items
            return {
                PageBase: {
                    __typename: 'PageBaseOutput' as const,
                    total: totalCount,
                    items: allItems,
                    facets,
                },
            } as SearchBlockQuery;
        },
        ...options,
    });
};